import React from 'react';
import PropTypes from 'prop-types';

export default class ConfigurableEnumForm extends React.Component {
  static propTypes = {
    enumValue: PropTypes.shape({
      label: PropTypes.string
    }).isRequired,
    formLabel: PropTypes.string,
    onChange: PropTypes.func.isRequired
  }

  static defaultProps = {
    formLabel: 'Label'
  }

  handleChange = (event) => {
    const { name, value } = event.target;

    this.props.onChange({ [name]: value });
  }

  render() {
    return (
      <div>
        <div className="form-group">
          <label>{this.props.formLabel}</label>
          <input
            className="form-control"
            name="label"
            value={this.props.enumValue.label}
            onChange={this.handleChange}
          />
        </div>
      </div>
    );
  }
}
